import React, { useState } from "react";
import "./MatriculaForm.css";
import logo from "../assets/logo.png";

export default function MatriculaForm() {
  const [formData, setFormData] = useState({
    prazoResolutiva: "",
    endereco: "",
    municipio: "",
    estado: "",
    cep: "",
    bairro: "",
    numero: "",
    complemento: "",
    latitude: "",
    longitude: "",
    tipo: "",
    valor: "",
    proprietario: "",
    locatario: "",
    agua: "",
    energia: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");

    try {
      const response = await fetch("/api/imoveis", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        alert("Imóvel cadastrado com sucesso!");
        setFormData({
          prazoResolutiva: "",
          endereco: "",
          municipio: "",
          estado: "",
          cep: "",
          bairro: "",
          numero: "",
          complemento: "",
          latitude: "",
          longitude: "",
          tipo: "",
          valor: "",
          proprietario: "",
          locatario: "",
          agua: "",
          energia: "",
        });
      } else {
        alert("Erro ao cadastrar imóvel.");
      }
    } catch (err) {
      console.error("Erro ao enviar dados:", err);
      alert("Erro ao cadastrar imóvel.");
    }
  };

  return (
    <div className="layout">
      <aside className="sidebar">
        <img src={logo} alt="Logo da Empresa" className="logo" />
        <h2>Menu</h2>
        <ul>
          <li>Gestão de Imóveis</li>
          <li>Matrícula de imóveis</li>
          <li>Locatários</li>
          <li>Relógio de Água</li>
          <li>Relógio de Energia</li>
          <li>Cidades</li>
          <li>Cartórios</li>
          <li>Local</li>
          <li>Proprietários</li>
          <li>Usuários</li>
          <li>Logs - Atividades</li>
        </ul>
      </aside>

      <main className="content">
        <h1>Matrícula de Imóveis</h1>
        <form className="form-section" onSubmit={handleSubmit}>
          {[
            "endereco",
            "municipio",
            "estado",
            "cep",
            "bairro",
            "numero",
            "complemento",
            "latitude",
            "longitude",
            "tipo",
            "valor",
            "proprietario",
            "locatario",
            "agua",
            "energia",
          ].map((field) => (
            <div key={field}>
              <label>{field.charAt(0).toUpperCase() + field.slice(1).replace(/([A-Z])/g, " $1")}</label>
              <input type={field === "valor" ? "number" : "text"} name={field} value={formData[field]} onChange={handleChange} />
            </div>
          ))}
          <div>
            <label>Prazo da Resolutiva</label>
            <input type="date" name="prazoResolutiva" value={formData.prazoResolutiva || ""} onChange={handleChange} />
          </div>
          <button type="submit">Cadastrar</button>
        </form>
      </main>
    </div>
  );
}
